export default __webpack_public_path__ + "static/media/story9.33893b5c.jpg";